/**
 * Exportación desde EstudyooBackendAdmin/Modules (legacy SQL).
 * Base: VUE_APP_API_URL → api/SyncDjango/...
 */
import axios from 'axios';

const API = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '');

export default {
  getCatalogo() {
    return axios.get(`${API}/SyncDjango/v1/catalogo`);
  },

  getPaquete(idColegio, params = {}) {
    return axios.get(`${API}/SyncDjango/v1/paquete/${idColegio}`, { params });
  },

  getAlumnosPorCurso(idColegio, idCurso) {
    return axios.get(`${API}/SyncDjango/v1/paquete/${idColegio}/alumnos`, {
      params: { idCurso },
    });
  },

  getContratoAlumno(idUsuario) {
    return axios.get(`${API}/SyncDjango/v1/alumno/${idUsuario}/contrato`);
  },

  getPreguntas(idEjeTematico, idCapitulo, idVideo = null) {
    const params = { idEjeTematico, idCapitulo };
    if (idVideo != null) params.idVideo = idVideo;
    return axios.get(`${API}/SyncDjango/v1/preguntas`, { params });
  },
};
